import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerMultiPromptTemplate,
  BackendMutationUpdateExpertMultiPromptTemplateArgs,
} from 'src/types/backend';

import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from './schema';

const MUTATION = gql`
  mutation UpdateExpertMultiPromptTemplate(
    $id: ID!
    $templateGroup: TemplateGroupEnum!
    $tags: [TemplateTagEnum!]
    $smallImage: String
    $bigImage: String
    $iconImage: String
    $wideImage: String
  ) {
    updateExpertMultiPromptTemplate(
      id: $id
      templateGroup: $templateGroup
      tags: $tags
      smallImage: $smallImage
      bigImage: $bigImage
      iconImage: $iconImage
      wideImage: $wideImage
    ) {
      ...CustomerMultiPromptTemplate
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
`;

type Variables = BackendMutationUpdateExpertMultiPromptTemplateArgs;
type Result = BackendCustomerMultiPromptTemplate;

export const updateExpertMultiPromptTemplate = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
